import { ContactResource, ContactSchema } from '../Api/Contact'

const relations = ['referralSource', 'importReferences', 'defaultExpenseAccount'];

export default {
    namespaced: true,
    state: {
        current: null,
    },
    mutations: {
        set(state, contact) {
            state.current = contact;
        },
        setActivity(state, activity) {
            state.current.activity = activity;
        }
    },
    actions: {
        load(context, id) {
            return new Promise((resolve, reject) => {
                ContactResource.find(id, { with: relations }).then(response => {
                    let contact = new ContactSchema(response.data);
                    context.commit('set', contact);
                    resolve();
                }, (e) => { handleApiError(e, reject) });
            });
        },
        delete(context, id) {
            return new Promise((resolve, reject) => {
                let resource = ContactResource.destroy(
                    id
                );

                resource.then(response => {
                    context.commit('set', null);

                    resolve(response.data);
                }, (error) => {
                    handleApiError(error, reject);
                });
            });
        },
        storeOrUpdate(context, contact) {
            return new Promise((resolve, reject) => {
                let resource = ContactResource.storeOrUpdate(
                    contact.id, contact
                );

                resource.then(response => {
                    context.commit('set', contact);

                    resolve(response.data);
                }, (error) => {
                    handleApiError(error, reject);
                });
            });
        },
    }
}